import { camelCase } from 'lodash';

const getCmsDetailsData = state => {
  const cmsDetailsData = state.CmsDetailsReducer.cmsDetailsData;
  if (!cmsDetailsData || cmsDetailsData.length === 0) {
    return null;
  }
  return transformCmsDetailsData(cmsDetailsData);
};

const getCmsDetailsDataLoading = state => {
  return state.CmsDetailsReducer.loading.cmsDetailsData;
};

const getCmsDetailsDataError = state => {
  return state.CmsDetailsReducer.error.cmsDetailsData;
};

export const CmsDetailsSelector = {
  getCmsDetailsData,
  getCmsDetailsDataLoading,
  getCmsDetailsDataError,
};

const transformCmsDetailsData = details => {
  const {
    cms_details_pages = [],
    media_path,
    device: { mobile, web, thumbnail },
  } = details;

  const excludedTitles = ['qwe', 'Machine Craft'];

  return cms_details_pages
    .filter(item => !excludedTitles.includes(item.page_title))
    .reduce((acc, curr) => {
      const titleKey = camelCase(curr.page_title);
      const cms_detail_page_contents = (
        curr.cms_detail_page_contents || []
      ).map(item => ({
        id: item.id,
        section_name: item.section_name,
        div_name: item.div_name,
        tag_word: item.tag_word,
        content_type: item.content_type,
        div_content: item.div_content,
        video_thumbnail_url: item.video_thumbnail_url
          ? item.video_thumbnail_url
          : '',
      }));
      acc[titleKey] = {
        id: curr.id,
        page_title: curr.page_title,
        artist_id: curr.artist_id,
        cms_page_id: curr.cms_page_id,
        is_display_read_more: false,
        cms_detail_page_contents,
        media_path,
        thumbnail,
        mobile,
        web,
      };
      return acc;
    }, {});
};
